<template >
  <div>
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1240">
          <v-card-title style="background-color:#006699;color:white;"></v-card-title>
          <v-data-table :headers="headers" :items="dados" :search="searchInDb" sort-by="data_" class="elevation-3">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col md="8">
                    <v-toolbar-title>Entrada - dados gerais</v-toolbar-title>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="3"></v-col>
                  <v-col md="3">
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="date" label="Seleciona a data inicial" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="3">
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="date2" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="date2" label="Seleciona a data final" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="date2" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.menu2.save(date2)"> OK </v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col md="1">
                    <v-btn small fab color="green" @click="getVendas()" style="color:white;"><v-icon>search</v-icon></v-btn>
                  </v-col>
                  <v-col md="1" v-if="dados.length">
                    <v-btn small fab color="primary" @click="gerarHTML()"><v-icon>print</v-icon></v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
            </template>
            <template v-slot:item.ordem="{ item }">
              <span>{{ dados.indexOf(item) + 1 }}</span>
            </template>
            <template v-slot:item.valorIliquido="{ item }">
              <span>{{ util.IntegerToMoneyValueFatura(item.valorIliquido) }}</span>
            </template>
            <template v-slot:item.valorAPagar="{ item }">
              <span>{{ util.IntegerToMoneyValueFatura(item.valorAPagar) }}</span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn fab dark small color="#006699" v-bind="attrs" v-on="on">
                    <v-icon dark>menu</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="SetEditItem(item)"><v-icon color="#006699" small>edit</v-icon>Editar</v-list-item>
                  <v-list-item @click="setEliminar(item)"><v-icon color="red" small>delete</v-icon>Eliminar</v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data> Selecione a data inicial e a data final para visualizar os dados!</template>
          </v-data-table>
          <v-card-actions>
            <v-row v-if="dados.length">
              <v-col md="6"></v-col>
              <v-col md="3"><span style="font-weight:bold;">Total de Multas:</span><v-chip>0,00 Kz</v-chip></v-col>
              <v-col md="3"><span style="font-weight:bold;">Total Geral:</span><v-chip>{{ util.IntegerToMoneyValueFatura(total) }}</v-chip></v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import axios from '../../../plugins/axios';
import utilitarios from '../../../plugins/utilitarios';
import impressaoService from '../../../services/impressaoService';
import impressaoUtilitario from '../../../utilitarios/impressao.utilitario';
export default {
  data: () => ({
    dados: [],
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    menu2: null,
    util: utilitarios,
    headers: [
      { text: 'Nº de Ordem.', value: 'ordem' },
      { text: 'Documento', value: 'descricao' },
      { text: 'Identificação do documento', value: 'numeroDocumento' },
      { text: 'Data', value: 'data_' },
      { text: 'estudante', value: 'cliente' },
      { text: 'Valor Ilíquido', value: 'valorIliquido' },
      { text: 'I.V.A', value: 'iva' },
      { text: 'Total', value: 'valorPago' },
      { text: 'Registrada por', value: 'nomeUsuario' },
    ],
    searchInDb: '',
    dialog: false,
    overlay: false,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    config: null,
    baseUrl: ''
  }),

  computed: {
    total() {
      let total_ = 0
      this.dados.forEach(element => {
        total_ += element.valorPago
      });
      return total_
    }
  },

  created() {
    this.config = impressaoUtilitario.getConfig();
    this.getUrlImpressao();
  },

  methods: {
    async getUrlImpressao() {
      this.overlay = true;
      try {
        this.baseUrl = await impressaoService.getBaseUrl().then((res) => res.data[0].url);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante o carregamento do endereço do servidor de impressão!');
      } finally {
        this.overlay = false;
      }
    },

    async getVendas() {
      try {
        this.overlay = true;
        let params = {
          date1: this.date,
          date2: this.date2
        }

        this.dados = await axios.post('VendasFindAllbydates', params).then((res) => res.data);
      } catch (error) {
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro ao carregar os seus dados.');
      } finally {
        this.overlay = false;
        if (this.dados.length === 0) {
          utilitarios.showAlertMessage('warning', 'Informação não encontrada.');
        }
      }
    },


    // Método responsavel por criar um HTML com os dados da coleção this.dados[]
    async gerarHTML() {
      try {
        this.$store.state.loading_pdf = true;
        let header = ` `;
        let dados = ``;
        let lastRow = ``;
        let i = 1;
        let periodo = ` 
            <table class="table2">
              <tr>
                <td>
                  <div class="logo">
                    <span><img class="logo_img" src="${this.baseUrl}readfile/`+ this.config.logo + `" alt="Logótipo da Universidade"/></span>
                    <br><span>`+ this.config.descricao + `</span>
                  </div>
                </td>
              </tr>
            </table>
            <div class="dados_academicos">
              <span>Relatório de entrada - Dados Gerais</span>
              <br><span>Gerada em: ` + this.data_hora() + `</span> 
            </div>`
        header = ` 
            <th class="table_header border_on_table">#</th>
            <th class="table_header border_on_table">Documento</th>  
            <th class="table_header border_on_table">Identificação</th>  
            <th class="table_header border_on_table">Data</th>  
            <th class="table_header border_on_table">Estudante</th>
            <th class="table_header border_on_table">Valor Líquido</th>
            <th class="table_header border_on_table">IVA</th>
            <th class="table_header border_on_table">Total</th>
            <th class="table_header border_on_table">Autor</th>`
        this.dados.forEach(element => {
          dados += `
            <tr>
              <td class="border_on_table">` + i + `</td>
              <td class="table_data data_disciplina border_on_table">` + element.descricao + `</td>
              <td class="table_data border_on_table">` + element.numeroDocumento + `</td>
              <td class="table_data border_on_table">` + element.data_movimentacao + `</td>
              <td class="table_data border_on_table">` + element.cliente + `</td>
              <td class="table_data border_on_table" style="text-align: right;">` + this.util.IntegerToMoneyValueFatura(element.valorIliquido) + `</td>
              <td class="table_data border_on_table" style="text-align: right;">` + this.util.IntegerToMoneyValueFatura(element.iva) + `</td>
              <td class="table_data border_on_table" style="text-align: right;">` + this.util.IntegerToMoneyValueFatura(element.valorPago) + `</td>
              <td class="table_data border_on_table">` + element.nomeUsuario + `</td>
            </tr>`
          i++
        })
        lastRow = `
          <tr class="border_on_table">
            <th colspan="8" style="text-align:right" bgcolor="#DCDCDC">Total Geral:</th>
            <td style="text-align:right" bgcolor="#DCDCDC">` + this.util.IntegerToMoneyValueFatura(this.total) + `</td>
          </tr>`

        this.html = `
            <html>
              <head>
                <style>
                  * {
                    font-family: "Times New Roman", sans-serif;
                  }
                  .table_header {
                    padding: 5px 3px;
                    text-align: center;
                    background-color: #DCDCDC;
                  }
                  .table_data {
                    text-align: center;
                    padding: 5px;
                  }
                  tr td.data_disciplina {
                    text-align: left;
                  }
                  .logo {
                    width: 100%;
                    text-align: center;
                    margin-bottom: 10px;
                  }
                  .logo_img {
                    width:90%;
                    max-width:50px;
                  }
                  
                  .dados_academicos {
                    border-radius: 15px;
                    border: 1px solid #000000;
                    padding: 15px; 
                    font-size:10px
                  }
                  .table1 {
                    width: 100%;
                    margin-top: 30px;
                  }
                  .table2 {
                    border: 0px solid black;
                    margin-left: 0px;
                    margin-right: auto;
                    width: 100%
                  }
                  .legenda {
                    margin-top: 20px;
                    font-size: 10px;
                  }
                  .border_on_table {
                    border: 1px solid #000;
                    text-align: center;
                  }
                  table, th, td {
                    border: 0px solid black;
                    border-collapse: collapse;
                    font-size: 8px;
                  }
                </style>
              </head>
              <body>
                ` + periodo + `
                <table class="table1">
                  <tr> ` + header + ` </tr>
                  <tr> ` + dados + ` </tr>
                  <tr> ` + lastRow + ` </tr>
                </table>
              </body>
            </html> `

            let options = {
              'format': 'A4',
              'border': {'right': '9mm', 'left': '9mm'},
              'header': {'height': '10mm'},
              'footer': {'height': '1mm'}
            }

            impressaoService.htmlToPdf(this.html, options);
      } catch (error) {
        this.$store.state.loading_pdf = false;
        utilitarios.showAlertMessage('warning', 'Ocorreu um erro durante a impressão do documento.');
      }
    },

    // Método responsavél por guardar a data atual
    data_hora() {
      let data = new Date()
      return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    }
  }
}
</script>
 
<style scoped></style>
